import {MessarioLaunchPendingIntent} from '@lib/messarioLaunch/types';

export const MESSARIO_LAUNCH_PENDING_KEY = 'messario_launch_pending';
export const MESSARIO_LAUNCH_PENDING_MAX_AGE = 10 * 60 * 1000;

export function saveMessarioLaunchPending(
  pending: MessarioLaunchPendingIntent,
  storage: Storage = window.sessionStorage
) {
  storage.setItem(MESSARIO_LAUNCH_PENDING_KEY, JSON.stringify(pending));
}

export function clearMessarioLaunchPending(
  storage: Storage = window.sessionStorage
) {
  storage.removeItem(MESSARIO_LAUNCH_PENDING_KEY);
}

export function getMessarioLaunchPending(
  storage: Storage = window.sessionStorage,
  now = Date.now()
): {pending?: MessarioLaunchPendingIntent, stale: boolean} {
  const value = storage.getItem(MESSARIO_LAUNCH_PENDING_KEY);
  if(!value) {
    return {stale: false};
  }

  try {
    const pending = JSON.parse(value) as MessarioLaunchPendingIntent;
    if(
      typeof pending.expectedUserId !== 'string' ||
      typeof pending.accountId !== 'string' ||
      typeof pending.panelUserId !== 'string' ||
      typeof pending.createdAt !== 'number'
    ) {
      clearMessarioLaunchPending(storage);
      return {stale: true};
    }

    if(now - pending.createdAt > MESSARIO_LAUNCH_PENDING_MAX_AGE) {
      clearMessarioLaunchPending(storage);
      return {stale: true};
    }

    return {pending, stale: false};
  } catch(err) {
    clearMessarioLaunchPending(storage);
    return {stale: true};
  }
}
